export const TOO_EARLY_TOO_TRANSFER_ERROR =
  "Pay date is too early to transfer funds, please schedule a date on or after the earliest pay date.";
